interface PageHeaderProps {
  title: string;
  description?: string;
}

export const PageHeader = ({
  title,
  description,
  children,
}: React.PropsWithChildren<PageHeaderProps>): React.ReactElement => (
  <header>
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div className="min-w-0 max-w-3/5">
        <h1 className="text-denim-800 text-2xl leading-7 font-medium">{title}</h1>
        {description && <p className="text-gray-400 mt-2 text-sm leading-4.5">{description}</p>}
      </div>
      {children ? <div className="flex shrink-0 items-center gap-2">{children}</div> : null}
    </div>
  </header>
);
